module.exports = __webpack_public_path__ + "img/contact.025764a3.jpg";